import React from "react";

const Progressbar = ({ title, value }) => {
  return (
    <div>
      <p className="text-uppercase font-weight-bold pt-3" align="justify">
        {title}
      </p>

      <div className="md-progress">
        <div
          className="progress-bar progress-bar-striped progress-bar-animated"
          role="progressbar"
          style={{ width: value + "%" }}
          aria-valuenow={value}
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </div>
    </div>
  );
};

export default Progressbar;
